import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const External = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M14.4 2.5a.5.5 0 1 0 0 1zM21 3h.5a.5.5 0 0 0-.5-.5zm-.5 6.6a.5.5 0 0 0 1 0zm-9.454 2.646a.5.5 0 1 0 .707.707L11.4 12.6zM10.2 5.9a.5.5 0 1 0 0-1zm-4.8-.5v-.5zM3 7.8h-.5zm0 10.8h-.5zm16.1-4.8a.5.5 0 0 0-1 0zM14.4 3v.5H21v-1h-6.6zM21 3h-.5v6.6h1V3zm0 0-.354-.354-9.6 9.6.354.354.353.353 9.6-9.6zM10.2 5.4v-.5H5.4v1h4.8zm-4.8 0v-.5a2.9 2.9 0 0 0-2.05.85l.353.353.353.354A1.9 1.9 0 0 1 5.4 5.9zm-1.697.703-.354-.353A2.9 2.9 0 0 0 2.5 7.8h1c0-.504.2-.987.556-1.343zM3 7.8h-.5v10.8h1V7.8zm0 10.8h-.5a2.9 2.9 0 0 0 .85 2.05l.353-.353.353-.354A1.9 1.9 0 0 1 3.5 18.6zm.703 1.697-.354.354A2.9 2.9 0 0 0 5.4 21.5v-1a1.9 1.9 0 0 1-1.344-.556zM5.4 21v.5h10.8v-1H5.4zm10.8 0v.5a2.9 2.9 0 0 0 2.05-.85l-.353-.353-.353-.354a1.9 1.9 0 0 1-1.344.557zm1.697-.703.354.354a2.9 2.9 0 0 0 .85-2.051h-1c0 .504-.2.987-.557 1.343zM18.6 18.6h.5v-4.8h-1v4.8z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(External) as SvgIcon;
export { ForwardRef as ReactComponent };
